<template>
    <!-- Latest Post -->
    <div class="widget widget-latest-post">
        <div class="widget-title">
            <h3>Postingan Terakhir</h3>
        </div>
        <div class="widget-body">

            <div v-for="news in newsList" :key="news.id" class="latest-post-aside media">
                <div class="lpa-left media-body">
                    <div class="lpa-title">
                        <h5><a href="#">{{ news.titel }}</a></h5>
                    </div>
                    <div class="lpa-meta">
                        <a class="name" href="#">
                            {{ news.user_id }}
                        </a>
                        <a class="date" href="#">
                            {{ formatDate(news.tgl_publish) }}
                        </a>
                    </div>
                </div>
                <div class="lpa-right">
                    <a href="#">
                        <img :src="`http://bkpsdm.kendalkab.go.id/bahurekso/packages/photo/${news.fav}`" class="card-img-top"
                            alt="..." />
                    </a>
                </div>
            </div>

        </div>
    </div>
    <!-- End Latest Post -->
</template>

<script>
import axios from "axios";

export default {
    name: "BeritaTerkini",
    data() {
        return {
            newsList: [],
            loading: true,
            error: null,
        };
    },
    methods: {
        async fetchNews() {
            try {
                const response = await axios.get(
                    "/content/berita?pages=1&limit=3"
                );
                this.newsList = response.data.data;
                // console.log(response.data)
            } catch (err) {
                this.error = "Gagal memuat berita. Coba lagi nanti.";
            } finally {
                this.loading = false;
            }
        },
        formatDate(date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString("id-ID", options);
        },
    },
    created() {
        this.fetchNews();
    },
};
</script>